import { render, staticRenderFns } from "./secretaryGet.vue?vue&type=template&id=83887fb0&scoped=true&"
import script from "./secretaryGet.vue?vue&type=script&lang=js&"
export * from "./secretaryGet.vue?vue&type=script&lang=js&"
import style0 from "./secretaryGet.vue?vue&type=style&index=0&id=83887fb0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83887fb0",
  null
  
)

export default component.exports